import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { LoadingPanel } from "src/components/loadingPanel";
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem, ChartSeriesLabels } from "@progress/kendo-react-charts";
import { PayRequestDashboardConstant as constants } from "../index.const";
import { useCallback, useMemo } from "react";

const PayRequestOverviewBox = (props) => {
  const history = useHistory();
  const { statusCount, periodFilter, setPeriodFilter, isPendingRequestsLoading, startDate, endDate, holdEnabled } = props;

  // Hold sits last among status buckets so the All Pay Requests card stays at the bottom.
  const orderedStatusCount = [...(statusCount || [])]
    .filter((item) => holdEnabled !== false || item.approval_status !== "Hold")
    .sort((a, b) => {
    const aHold = a.approval_status === "Hold" ? 1 : 0;
    const bHold = b.approval_status === "Hold" ? 1 : 0;
    return aHold - bHold;
  });
  const allCount =
    orderedStatusCount.length > 0 &&
    orderedStatusCount.reduce(
      (acc, item) => {
        acc.approval_status = "All Pay Requests";
        acc.task_count += item.task_count;
        acc.color = "#00A1E4";
        acc.status_Const = "ALL";
        return acc;
      },
      { task_count: 0 }
    );
  const statusList = allCount ? [...orderedStatusCount, allCount] : [];

  const handleCardClick = useCallback(
    (item) => {
      history.push({
        pathname: "/approver_pay_request_overview",
        state: { status: item.approval_status === "All Pay Requests" ? "ALL" : item.approval_status, startDate, endDate },
      });
    },
    [history, startDate, endDate]
  );

  return (
    <div className="payRequestOverview">
      <div className="widget-header">
        <h3>Pay Request Overview</h3>
        <DropDownList
          data={constants.periodFilters}
          textField="text"
          dataItemKey="value"
          value={constants.periodFilters.find((item) => item.value === periodFilter)}
          onChange={(e) => setPeriodFilter(e.target.value.value)}
          className="period-filter"
          style={{ border: "none", backgroundColor: "transparent" }}
        />
      </div>
      <div className="widget-content">
        {isPendingRequestsLoading && <LoadingPanel gridId="pay-request-overview-grid" />}
        {!isPendingRequestsLoading && orderedStatusCount.length > 0 ? (
          <div className="chart-container">
            {console.log("loading")}
            <div className="chart-wrapper">
              <Chart transitions={false}>
                <ChartSeries>
                  <ChartSeriesItem
                    type="donut"
                    data={orderedStatusCount}
                    categoryField="approval_status"
                    field="task_count"
                    colorField="color"
                    holeSize={60}
                    tooltip={{
                      visible: true,
                      render: ({ point, dataItem }) => {
                        const category = dataItem?.category || point?.category || "Unknown";
                        const value = dataItem?.value || point?.value || 0;
                        return (
                          <div>
                            <strong>{category} : </strong>
                            {value}
                          </div>
                        );
                      },
                    }}
                  >
                    <ChartSeriesLabels visible={false} />
                  </ChartSeriesItem>
                </ChartSeries>
                <ChartLegend
                  position="bottom"
                  orientation="horizontal"
                  align="center"
                  labels={{
                    font: "12px Arial",
                  }}
                  markers={{
                    type: "circle",
                    size: 30,
                  }}
                />
              </Chart>
            </div>
            <div className="request-status-list">
              {statusList &&
                statusList.length > 0 &&
                statusList.map((item, index) => (
                  <div
                    key={index}
                    className="request-status-item"
                    onClick={() => handleCardClick(item)}
                    style={{ border: `1px solid` + item.color }}
                  >
                    <div className="request-status-indicator" style={{ backgroundColor: item.color }}></div>
                    <span className="request-status-type">{item.approval_status}</span>
                    <span className="request-status-hours">{item.task_count}</span>
                  </div>
                ))}
            </div>
          </div>
        ) : (
          <div className="no-data-found">{!isPendingRequestsLoading && <p>No data found</p>}</div>
        )}
      </div>
    </div>
  );
};

export default PayRequestOverviewBox;
